export default __webpack_public_path__ + "static/media/taxi.inline.90ae542f.svg";